module.exports = __webpack_public_path__ + "media/images/logo-instagram-da54482f32b2376bb7fc9ff2d1b45ab9.svg";